// extracted by mini-css-extract-plugin
module.exports = {"franchiseJourneyBecomeOwner":"uUVQD","textCard":"_1nTA9"};